module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAADFBMVEVHcEwAAAAAAAAAAAALttw0AAAABHRSTlMA/4Kc/Qd30QAAAClJREFUeNrlyrERAAAIwkDE/Xe2pLSE07R5hFVcAENEvxACpz/NH/phDQ+eAIPWLXhKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/right_arrow.png
// module id = nOcu
// module chunks = 215